import { isEnabled } from "lib/@components/feature"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import {
    ClassificationArea,
    SkillSetArea,
    TaskContent,
    TaskNotes,
    TaskRowEntryWrapper,
    TaskRowStart,
    TaskTitle,
    TimeAndFrequency,
} from "slot-definitions"
import { FEATURE_FLAG_COMPONENT_MACROS } from "./feature-flag-component-macros"
import { ComponentRefClassification } from "./plugins/component-ref-classification"
import { ComponentRefTimeFrequency } from "./plugins/component-ref-time-frequency"
import { ComponentRefSkillSet } from "./plugins/component-ref-skillset"
import { ComponentRefTaskWrapper } from "./plugins/component-ref-task-wrapper"
import { ComponentRefRowLink } from "./plugins/component-ref-row-link"
import { ComponentRefTitle } from "./plugins/component-ref-title"
import { ComponentRefContent } from "./plugins/component-ref-content"
import { ComponentRefNotes } from "./plugins/component-ref-notes"

// Wrap each task row with component-link context so the slot plugs below
// can replace the default editors with inherited field views.
TaskRowEntryWrapper.plug(
    <ComponentRefTaskWrapper
        $lazy
        if={(c) => isEnabled(FEATURE_FLAG_COMPONENT_MACROS) && c.isAuthoringScheduleEditor}
    />
)

// Row-level "link component" button — opens selector when no component is linked yet.
TaskRowStart.plug(
    <ComponentRefRowLink $lazy if={(c) => isEnabled(FEATURE_FLAG_COMPONENT_MACROS) && c.isAuthoringScheduleEditor} />
)

ClassificationArea.plug(
    replaceAllWith(
        <ComponentRefClassification
            $lazy
            priority={200}
            if={(c) => isEnabled(FEATURE_FLAG_COMPONENT_MACROS) && c.isAuthoringScheduleEditor}
        />,
        200
    )
)

TimeAndFrequency.plug(
    replaceAllWith(
        <ComponentRefTimeFrequency
            $lazy
            priority={200}
            if={(c) => isEnabled(FEATURE_FLAG_COMPONENT_MACROS) && c.isAuthoringScheduleEditor}
        />,
        200
    )
)

SkillSetArea.plug(
    replaceAllWith(
        <ComponentRefSkillSet
            $lazy
            priority={200}
            if={(c) => isEnabled(FEATURE_FLAG_COMPONENT_MACROS) && c.isAuthoringScheduleEditor}
        />,
        200
    )
)

TaskTitle.plug(
    replaceAllWith(
        <ComponentRefTitle
            $lazy
            priority={200}
            if={(c) => isEnabled(FEATURE_FLAG_COMPONENT_MACROS) && c.isAuthoringScheduleEditor}
        />,
        200
    )
)

TaskContent.plug(
    replaceAllWith(
        <ComponentRefContent
            $lazy
            priority={200}
            if={(c) => isEnabled(FEATURE_FLAG_COMPONENT_MACROS) && c.isAuthoringScheduleEditor}
        />,
        200
    )
)

TaskNotes.plug(
    replaceAllWith(
        <ComponentRefNotes
            $lazy
            priority={200}
            if={(c) => isEnabled(FEATURE_FLAG_COMPONENT_MACROS) && c.isAuthoringScheduleEditor}
        />,
        200
    )
)
